import React, { CSSProperties } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const DOTS = [0, 1, 2, 3, 4, 5, 6, 7];
const SIZE = 84;
const RADIUS = 30;
const DOT_SIZE = 9;

const dotStyles = () => {
  const center = SIZE / 2 - DOT_SIZE / 2;
  const styles: Record<string, CSSProperties> = {};

  DOTS.forEach((index) => {
    const angle = ((index * 360) / DOTS.length - 90) * (Math.PI / 180);

    styles[`dot${index}`] = {
      left: Math.round(center + Math.cos(angle) * RADIUS),
      top: Math.round(center + Math.sin(angle) * RADIUS),
      animationDelay: `${index * 0.12}s`,
    };
  });

  return styles;
};

const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
    width: SIZE,
    height: SIZE,
  },
  dot: {
    position: "absolute",
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: "50%",
    backgroundColor: "#E0E0E0",
    animation: "$pulse 0.96s linear infinite",
  },
  "@keyframes pulse": {
    "0%, 70%, 100%": {
      backgroundColor: "#E0E0E0",
      transform: "scale(1)",
    },
    "20%": {
      backgroundColor: "#39797A",
      transform: "scale(1.7)",
    },
  },
  ...dotStyles(),
}));

export default function DotSpinner({ className = "" }) {
  const classes: Record<string, string> = useStyles();

  return (
    <Box className={`${classes.root} ${className}`}>
      {DOTS.map((dot) => (
        <span key={dot} className={`${classes.dot} ${classes[`dot${dot}`]}`} />
      ))}
    </Box>
  );
}